
import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import '../view/css/NavBar.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import {LoginModalView} from '../view/LoginModalView';

export function LoginModal() {
    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [error, setError] = React.useState(false);
    const [check, setCheck] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setError(false);
        setEmail("");
        setPassword("");
    };

    const login = (e) => {
        console.log("Entered login function");
        e.preventDefault();
        firebase.auth().signInWithEmailAndPassword(email.toLowerCase(), password).then((u) => {
        }).catch((error) => {
            console.log(error);
            setError(true);
        });
    }

    const inputEmail = (e) => {
        setEmail(e.target.value)
        console.log(e.target.value);
        //this.setState({ [e.target.name]: e.target.value });
        checking();
    }

    const inputPassword = (e) => {
        setPassword(e.target.value)
        //this.setState({ [e.target.name]: e.target.value });
    }

    const checking = () => {
        if (checkAcc()) {
            //passes, logs in fine
            this.setCheck(true);
        }
    }

    const checkAcc = () => {
        var firestore = firebase.firestore();
        var user = firestore.collection("Users").where("email", "==", email);
        console.log(email);
        if (!user || user.email === undefined) {
            console.log("Failed test: user is null");
            console.log("Email: " + user.email);
            return false
        } else {
            console.log("Passed test: user exists. User is : " + user.email);
            return true;
        }
    }

    return (
        <LoginModalView login={login} check={check} handleClickOpen={handleClickOpen} open={open} handleClose={handleClose} error={error} inputEmail={inputEmail} email={email} inputPassword={inputPassword} password={password}/>
    );
}